import strReplace from '@/js/components/strReplace'

const main = () => {
    if (!document.querySelector('#page-entry-branch')) return false;

    $('.select-type a').eq(0).on('click', e => {
        $(e.currentTarget).addClass('active')
        $('.select-shop').fadeIn()
    })

    $('.tel-search').submit(e => {
        let btnObj = $(e.currentTarget).find('button')
        $(e.currentTarget).find('.error-message,.message').remove()
        let phone = btnObj.prev('input').val()
        phone = strReplace.toEnNo(phone)
        $('.select-restaurant .items').empty()
        $('.restaurant-entry').hide()

        if (!phone.match(/^0\d{1,3}\-?\d{1,4}\-?\d{3,4}$/)) {
            btnObj.after($('<p />').addClass('error-message').text('電話番号が正しく入力されていません'))
            return false
        }
        $.ajax({
            url: '/entry/api/search',
            type: 'POST',
            data: {
                phone,
            },
            dataType: 'json',
        })
            .done(resp => {
                let message
                let item = $('.template > label').clone()
                $('.restaurant-entry').find('button.submit').removeClass('disabled')
                if (!resp.length) {
                    message = '対象の店舗がないか、すでにエントリーが完了しています。'
                    btnObj.after($('<p />').addClass('error-message').text(message))
                    return
                } else if (resp.length > 1) {
                    message = '対象店舗が複数あります。申込みを行うレストランを選択してください。'
                    $('.restaurant-entry').prepend($('<p />').addClass('message').text(message))
                }
                resp.forEach((_val, _idx) => {
                    let tmpl = item.clone()
                    tmpl.find('.name').html(`${_val.restaurant} <span>(最新エントリー: ${_val.entry_year}年)<span>`)
                    tmpl.find('input[type="radio"]').val(_val.id).prop('disabled', _val.email_exists == 0)
                    if (_val.email_exists == 0) {
                        let message = '<p>過去データは登録されていますが、メールアドレスが登録されていないため選択できません。<br>直接事務局へお問い合わせください。</p><p class="addr">ダイナースクラブ フランス レストランウィーク事務局<br>Mail : <a href="mailto:office@francerestaurantweek.com">office@francerestaurantweek.com</a><br>TEL : <a href="tel:0335157033">03-3515-7033</a></p>'
                        tmpl.append($('<div />').addClass('message').html(message))
                    }
                    $('.select-restaurant .items').append(tmpl)
                })
                if (resp.length == 1) {
                    $('.select-restaurant .items').find('input[type="radio"]').first().prop('checked', true)
                }
                if (resp.filter(_val => _val.email_exists == 1).length == 0) {
                    $('.restaurant-entry').find('.submit_area').hide()
                }else{
                    $('.restaurant-entry').find('.submit_area').show()
                }
                $('.restaurant-entry').fadeIn()

                const position = $('#search-result').offset().top
                $('body,html').animate({ scrollTop: position }, 400, 'swing')
            })
        return false
    })


    $('form#entry-form').submit(e => {
        $(e.currentTarget).find('.error-message').remove()
        if (!$('.consent input[type="checkbox"]').prop('checked')) {
            $('.consent').append($('<div><p class="error-message">参加条件を確認のうえ同意してください。</p></div>'))
            return false
        }
        if (!$('.select-restaurant input[name="select_restaurant"]:checked').val()) {
            $('.select-restaurant').append($('<div><p class="error-message">レストランを選択してください。</p></div>'))
            return false
        }
        return true
    })
}
export default main;